/**
 * Entrada Delete Dialog - Confirmação de exclusão de entrada
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { EntradaCompleta } from "@/types/entrada";
import { format } from "date-fns";
import { Loader2 } from "lucide-react";

interface EntradaDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  entrada: EntradaCompleta | null;
  onConfirm: () => void;
  isDeleting: boolean;
}

export function EntradaDeleteDialog({
  open,
  onOpenChange,
  entrada,
  onConfirm,
  isDeleting,
}: EntradaDeleteDialogProps) {
  if (!entrada) return null;

  const formatCurrency = (value: number | null | undefined) => {
    if (value === null || value === undefined) return "R$ 0,00";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir entrada?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2">
              <p>Esta ação não pode ser desfeita. A entrada e todos os seus itens serão permanentemente removidos.</p>
              
              <div className="mt-4 p-4 bg-muted rounded-lg space-y-1 text-sm">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Data:</span>
                  <span className="font-medium text-foreground">
                    {format(new Date(entrada.cabecalho.data_entrada), 'dd/MM/yyyy')}
                  </span>
                </div>
                {entrada.cabecalho.fornecedor_nome && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Fornecedor:</span>
                    <span className="font-medium text-foreground">
                      {entrada.cabecalho.fornecedor_nome}
                    </span>
                  </div>
                )}
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Itens:</span>
                  <span className="font-medium text-foreground">{entrada.itens.length}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Total:</span>
                  <span className="font-medium text-foreground">
                    {formatCurrency(entrada.totais.total_geral_documento)}
                  </span>
                </div>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isDeleting && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            {isDeleting ? "Excluindo..." : "Excluir"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
